"use strict";
module.exports = Object.freeze({
    VARIABLE: 'variable',
    CONSTANT: 'constant',
});
//# sourceMappingURL=operandTypes.js.map